import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { FaFilter, FaSlidersH } from "react-icons/fa";
import { BASE_URL } from '../../../commonConfig/ApiConfig';
import WorkspaceSidePanel from "components/cmn_workspace/workspace_button";
import WorkspaceButton from "components/pages/workspacebtn/workspacebtn";
import { setWorkspaceLoaded } from 'store/workspaceSlice';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const Tablechart = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Workspace toggle state
  const [showWorkspace, setShowWorkspace] = useState(true);
  const dispatch = useDispatch();
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);
  const handleVisualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
  };
  const handleSaveSuccess = (workspaceData) => {
    alert(`Workspace "${workspaceData.name}" saved successfully!`);

    // Always load the saved workspace as current
    if (workspaceData.id && workspaceData.name) {
      setTimeout(() => {
        dispatch(setWorkspaceLoaded({
          id: workspaceData.id,
          name: workspaceData.name,
          workspace: workspaceData
        }));
      }, 100);
    }
  };


  const { formattedPayload, payload, } = location.state || {};
  const mainpayload = payload;
  const mainformattedpayload = formattedPayload;

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 30;

  useEffect(() => {
    const fetchData = async () => {
      if (!mainpayload) return;

      setLoading(true);
      setError(null);

      try {
        // Uncomment for real API call
        const res = await axios.post(`${BASE_URL}indicators/table-chart`, mainpayload);
        //setApiResponse(dummaydata); // Using dummy data
        setApiResponse(res.data); // Using dummy data
      } catch (err) {
        setError('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Reset to first page on data change
    setCurrentPage(1);
  }, [apiResponse]);

  if (loading) return <div className="text-center my-4">Loading...</div>;
  if (error || !apiResponse || !apiResponse.data || !apiResponse.headers)
    return (
      <div className="alert alert-danger">Error: {error || 'No data available'}</div>
    );

  const { headers, data } = apiResponse;

  const locations = data.map((loc) => ({
    code: loc.lgd_code,
    name: loc.lgd_name,
    geo_level_code: loc.geo_level_code,
    loc_data: loc.loc_data,
  }));

  // const getValuesForIndicator = (loc_data, indicator_code) => {
  //   const indicatorObj = loc_data.find((obj) => Object.keys(obj)[0] === indicator_code.toString());
  //   return indicatorObj ? indicatorObj[indicator_code.toString()].values : [];
  // };
  const getValuesForIndicator = (loc_data, indicator_code) => {
    const match = loc_data.find((item) => item && item[indicator_code] !== undefined);
    const indicator = match?.[indicator_code];
    return indicator && indicator.values ? indicator.values : [];
  };



  const indicatorHeaders = headers.map((header) => ({
    i_code: header.i_code,
    i_name: header.i_name,
    i_date: header.i_date,
    subindicators: header.si_name.length > 0 ? header.si_name : [null],
  }));

  // Sort by geo_level_code, then alphabetically
  const sortedLocations = [...locations].sort((a, b) => {
    if (a.geo_level_code !== b.geo_level_code) {
      return a.geo_level_code - b.geo_level_code;
    }
    return a.name.localeCompare(b.name);
  });

  const totalPages = Math.ceil(sortedLocations.length / rowsPerPage);

  const paginatedLocations = sortedLocations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const exportToCSV = () => {
    if (!apiResponse) return;

    let csvRows = [];

    // First header row: Location + indicator names
    const headerRow1 = ['"Location"'];
    indicatorHeaders.forEach((indicator) => {
      headerRow1.push(`${indicator.i_name}`);
      for (let i = 1; i < indicator.subindicators.length; i++) {
        headerRow1.push('""');
      }
    });
    csvRows.push(headerRow1.join(','));

    // Second header row: subindicators
    const headerRow2 = ['""'];
    indicatorHeaders.forEach((indicator) => {
      indicator.subindicators.forEach((sub) => {
        const subName = sub ? `${sub}` : '""'; // if sub is empty or null → blank
        headerRow2.push(subName);
      });
    });
    csvRows.push(headerRow2.join(','));

    // Data rows: Location + values
    sortedLocations.forEach((loc) => {
      const row = [`${loc.name}`];
      indicatorHeaders.forEach((indicator) => {
        const values = getValuesForIndicator(loc.loc_data, indicator.i_code);
        indicator.subindicators.forEach((_, idx) => {
          const cell_value = values[idx] !== undefined && values[idx] !== null ? values[idx] : '-'
          row.push('"' + cell_value + '"');
        });
      });
      csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const timestamp = new Date().toISOString()
      .replace(/T/, '')      // Replace 'T' with ''
      .replace(/:/g, '-')     // Replace ':' with '-'
      .replace(/\..+/, '');   // Remove milliseconds

    const filename = `data_table_${timestamp}.csv`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <WorkspaceButton
        showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
      />
      <WorkspaceSidePanel showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
        onVisualize={handleVisualize}
        onSaveSuccess={handleSaveSuccess} />
      <div className="container mt-4">
        <h2 className="mb-3">Data Table</h2>
        <div className='mb-3 '>
          <button
            className="btn btn-outline-secondary"
            onClick={() =>
              navigate("/mapconfig", { state: mainformattedpayload })
            }
          >
            <FaSlidersH className="me-1" /> Go Back to Table Configuration
          </button><OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id="filter-tooltip">
                <ol className="mb-0 ps-3">
                  <li>Click on 'Go to Chart configuration' to add more indicators to the chart from the workspace.</li>
                  <li>Go to 'Home' menu link to add additional indicators to the workspace.</li>
                </ol>
              </Tooltip>
            }
          >
            <span>
              <MdInfoOutline size={20} style={{ cursor: "pointer", color: "#000000" }} />
            </span>
          </OverlayTrigger>
        </div>
        <div className="mb-3 text-end">
          <button className="btn btn-sm btn-primary" onClick={exportToCSV}>
            Export as CSV
          </button>
        </div>
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-secondary sticky-top">
              <tr>
                <th rowSpan={2}>Location</th>
                {indicatorHeaders.map((indicator, i) =>
                  indicator.subindicators.length === 1 && indicator.subindicators[0] === indicator.i_name ? (
                    <th key={i} rowSpan={2}>
                      {`${indicator.i_name} (${indicator.i_date})`}

                    </th>
                  ) : (
                    <th key={i} colSpan={indicator.subindicators.length}>
                      {`${indicator.i_name} (${indicator.i_date}) `}
                    </th>
                  )
                )}
              </tr>
              {indicatorHeaders.some(
                (indicator) => indicator.subindicators.length > 1 || indicator.subindicators[0] !== indicator.i_name
              ) && (
                  <tr>
                    {indicatorHeaders.map((indicator, i) =>
                      indicator.subindicators.length === 1 && indicator.subindicators[0] === indicator.i_name
                        ? null
                        : indicator.subindicators.map((sub, j) => (
                          <th key={`${i}-${j}`}>{sub}</th>
                        ))
                    )}
                  </tr>
                )}
            </thead>

            <tbody>
              {paginatedLocations.map((loc) => (
                <tr key={loc.code}>
                  <td>{loc.name}</td>
                  {indicatorHeaders.map((indicator, i) => {
                    const values = getValuesForIndicator(loc.loc_data, indicator.i_code);
                    return indicator.subindicators.length > 1
                      ? indicator.subindicators.map((_, j) => (
                        <td key={`${i}-${j}-${loc.code}`}>
                          {values[j] !== undefined && values[j] !== null ? values[j] : '—'}
                        </td>
                      ))
                      : (
                        <td key={`${i}-0-${loc.code}`}>
                          {values[0] !== undefined && values[0] !== null ? values[0] : '—'}
                        </td>
                      );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="d-flex justify-content-between align-items-center my-3">
          <button
            className="btn btn-primary"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="btn btn-primary"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default Tablechart;
